import React, { Fragment, useCallback, useState } from 'react';
import EngineScoringContainer from './EngineScoringContainer';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from '../../../../utils/functions';
import Header from './header/Header';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const TestEngineScoringRoute = props => {
  const historyContext = useHistoryWithContext();
  const engineScoringId = props.match.params.engineScoringId && getInt(props.match.params.engineScoringId);
  const entityIdentifier = props.match.params.entityIdentifierForTest;

  const [title, setTitle] = useState('');
  const [canTestScoring, setCanTestScoring] = useState(true);
  const { getElemByAreaKey } = props;

  const onChangeTitle = useCallback(title => {
    setTitle(title);
  }, []);

  const onRedirect = useCallback(
    engineScoringId => {
      historyContext.push(`/scoringEngine/${engineScoringId}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>

      <EngineScoringContainer
        canTestScoring={canTestScoring}
        setCanTestScoring={setCanTestScoring}
        engineScoringId={engineScoringId}
        onRedirect={onRedirect}
        onChangeTitle={onChangeTitle}
        openScoringTest={true}
        entityIdentifierForTest={entityIdentifier}
      />
    </Fragment>
  );
};

TestEngineScoringRoute.propTypes = {
  match: PropTypes.object.isRequired,
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(withRouter(TestEngineScoringRoute));
